<app-breadcrumbs></app-breadcrumbs>
<div [cfaLoading]="isLoading">
  <button mat-raised-button (click)="flip = !flip" color="primary" id="flip-button" class="icon-only-button">
    <mat-icon>map</mat-icon>
  </button>
  <mat-form-field id="filter-field">
    <input matInput [(ngModel)]="filterText" (keyup)="applyFilter($event.target.value)" placeholder="Filter">
  </mat-form-field>
  <div class="toggle-container">
    <mat-slide-toggle id="lab-toggle" [(ngModel)]="hideLabs" (change)="onToggle()">Hide labs
    </mat-slide-toggle>
    <mat-slide-toggle id="future-toggle" [(ngModel)]="hideFutures" (change)="onToggle()">Hide
      Futures
    </mat-slide-toggle>
    <mat-slide-toggle id="remodel-toggle" [(ngModel)]="hideRemodels" (change)="onToggle()">Hide
      Remodels
    </mat-slide-toggle>
    <mat-slide-toggle id="backup-toggle" [(ngModel)]="showOnBackup" (change)="onToggle()">Show On
      Backup
    </mat-slide-toggle>
    <mat-slide-toggle id="dual-lte-toggle" [(ngModel)]="showDualLte" (change)="onToggle()">Show Dual
      LTE
    </mat-slide-toggle>
    <mat-slide-toggle id="hard-down-toggle" [(ngModel)]="showHardDown" (change)="onToggle()">Show
      Hard Down
    </mat-slide-toggle>
  </div>
</div>
<div class="flip-card">
  <div class="flip-card-inner" [ngClass]="{flip: flip}">
    <div class="flip-card-front">
      <div id="restaurant-table-wrapper">
        <table id="restaurants-table" #restaurantsTable mat-table matSort [dataSource]="dataSource"
          class="mat-elevation-z8">
          <ng-container matColumnDef="storeNumber">
            <th mat-header-cell *matHeaderCellDef mat-sort-header> Store Number </th>
            <td class="store-number-cell" mat-cell *matCellDef="let restaurant"
              [routerLink]="['/health/device']" [queryParams]="{storeNumber:restaurant.location.number}">
            {{restaurant.location.number}} </td>
          </ng-container>
          <ng-container matColumnDef="locationName">
            <th mat-header-cell *matHeaderCellDef mat-sort-header> Location Name </th>
            <td mat-cell *matCellDef="let restaurant"> {{restaurant.location.name}} </td>
          </ng-container>
          <ng-container matColumnDef="locationStatus">
            <th mat-header-cell *matHeaderCellDef mat-sort-header> Location Status </th>
            <td mat-cell *matCellDef="let restaurant"> {{restaurant.location.status}} </td>
          </ng-container>
          <ng-container matColumnDef="locationTimeZone">
            <th mat-header-cell *matHeaderCellDef mat-sort-header> Time Zone </th>
            <td mat-cell *matCellDef="let restaurant"> {{restaurant.location.timezone}} </td>
          </ng-container>
          <ng-container matColumnDef="networkState">
            <th mat-header-cell *matHeaderCellDef mat-sort-header> Network State </th>
            <td mat-cell *matCellDef="let restaurant">
              @if (restaurant.networkState === NETWORK_STATE.ON_WAN1) {
                <span class="info-chip chip-healthy" [matTooltip]="restaurant.networkStateEvaluation?.tooltip"
                  [matTooltipClass]="'my-tooltip'">
                  <mat-icon>check_circle</mat-icon>
                  On WAN1
                </span>
              }
              @if (restaurant.networkState === NETWORK_STATE.ON_WAN2) {
                <span class="info-chip chip-warning" [matTooltip]="restaurant.networkStateEvaluation?.tooltip"
                  [matTooltipClass]="'my-tooltip'">
                  <mat-icon>signal_cellular_alt</mat-icon>
                  On WAN2
                </span>
              }
              @if (restaurant.networkState === NETWORK_STATE.EM_FAILOVER) {
                <span class="info-chip chip-unhealthy" [matTooltip]="restaurant.networkStateEvaluation?.tooltip"
                  [matTooltipClass]="'my-tooltip'">
                  <mat-icon>priority_high</mat-icon>
                  EM Failover
                </span>
              }
              @if (restaurant.networkState === NETWORK_STATE.OFFLINE) {
                <span class="info-chip chip-unhealthy" [matTooltip]="restaurant.networkStateEvaluation?.tooltip"
                  [matTooltipClass]="'my-tooltip'">
                  <mat-icon>block</mat-icon>
                  Offline
                </span>
              }
              @if (restaurant.networkState === NETWORK_STATE.UNKNOWN) {
                <span class="info-chip chip-warning" [matTooltip]="restaurant.networkStateEvaluation?.tooltip"
                  [matTooltipClass]="'my-tooltip'">
                  <mat-icon>help_outline</mat-icon>
                  Circuit Unknown
                </span>
              }
            </td>
          </ng-container>
          <ng-container matColumnDef="merakis">
            <th mat-header-cell *matHeaderCellDef mat-sort-header> Merakis </th>
            <td mat-cell *matCellDef="let restaurant">
              @for (meraki of restaurant.merakis; track meraki) {
                <span>
                  @if (meraki.status=='online') {
                    <mat-icon
                      matTooltip="name: {{meraki.name}}&#13;serial: {{meraki.serial}}&#13;public ip: {{meraki.publicIp}}"
                      [matTooltipClass]="'my-tooltip'"
                      class="connected-icon">
                      check_circle_outline
                    </mat-icon>
                  }
                  @if (meraki.status=='offline') {
                    <mat-icon
                      matTooltip="name: {{meraki.name}}&#13;serial: {{meraki.serial}}&#13;public ip: {{meraki.publicIp}}"
                      [matTooltipClass]="'my-tooltip'"
                      class="disconnected-icon">
                      highlight_off
                    </mat-icon>
                  }
                </span>
              }
            </td>
          </ng-container>
          <ng-container matColumnDef="fortigates">
            <th mat-header-cell *matHeaderCellDef mat-sort-header> FortiGates </th>
            <td mat-cell *matCellDef="let restaurant">
              @for (fortigate of restaurant.fortigates; track fortigate) {
                <span>
                  @if (fortigate.conn_status==1) {
                    <mat-icon
                      matTooltip="name: {{fortigate.hostname}}&#13;serial: {{fortigate.sn}}&#13;fortimanager ip: {{fortigate.ip}}"
                      [matTooltipClass]="'my-tooltip'"
                      class="connected-icon">
                      check_circle_outline
                    </mat-icon>
                  }
                  @if (fortigate.conn_status==2) {
                    <mat-icon
                      matTooltip="name: {{fortigate.hostname}}&#13;serial: {{fortigate.sn}}&#13;fortimanager ip: {{fortigate.ip}}"
                      [matTooltipClass]="'my-tooltip'"
                      class="disconnected-icon">
                      highlight_off
                    </mat-icon>
                  }
                </span>
              }
            </td>
          </ng-container>
          <ng-container matColumnDef="cradlepoints">
            <th mat-header-cell *matHeaderCellDef mat-sort-header> Cradlepoints </th>
            <td mat-cell *matCellDef="let restaurant">
              @for (cradlepoint of restaurant.cradlepoints; track cradlepoint) {
                <span>
                  @if (cradlepoint.state=='online') {
                    <mat-icon
                      matTooltip="name: {{cradlepoint.name}}&#13;serial: {{cradlepoint.serial_number}}&#13;public ip: {{cradlepoint.ipv4_address}}"
                      [matTooltipClass]="'my-tooltip'"
                      class="connected-icon">
                      check_circle_outline
                    </mat-icon>
                  }
                  @if (cradlepoint.state=='offline') {
                    <mat-icon
                      matTooltip="name: {{cradlepoint.name}}&#13;serial: {{cradlepoint.serial_number}}&#13;public ip: {{cradlepoint.ipv4_address}}"
                      [matTooltipClass]="'my-tooltip'"
                      class="disconnected-icon">
                      highlight_off
                    </mat-icon>
                  }
                </span>
              }
            </td>
          </ng-container>
          <ng-container matColumnDef="mists">
            <th mat-header-cell *matHeaderCellDef mat-sort-header> Mists </th>
            <td mat-cell *matCellDef="let restaurant">
              @for (mist of restaurant.mists; track mist) {
                <span>
                  @if (mist.connected==true) {
                    <mat-icon
                      matTooltip="name: {{mist.name}}"
                      [matTooltipClass]="'my-tooltip'"
                      class="connected-icon">
                      check_circle_outline
                    </mat-icon>
                  }
                  @if (mist.connected==false) {
                    <mat-icon
                      matTooltip="name: {{mist.name}}"
                      [matTooltipClass]="'my-tooltip'"
                      class="disconnected-icon">
                      highlight_off
                    </mat-icon>
                  }
                </span>
              }
            </td>
          </ng-container>
          <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
          <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
        </table>
        <mat-paginator [pageSizeOptions]="[10, 20, 30, 50]" showFirstLastButtons></mat-paginator>
      </div>
    </div>
    <div class="flip-card-back">
      <div id="map"></div>
    </div>
  </div>
</div>